import React,{Suspense} from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'
import { UserProvider } from './context'
import { createBrowserHistory } from 'history'
import './i18n'; // Import your i18n configuration here


import getAWSApolloClient from './apollo.config'
import store from './store'
const client = getAWSApolloClient()
const history = createBrowserHistory()

const app = (
  <Suspense fallback={<div>Loading...</div>}>

  <ApolloProvider client={client}>
    <Provider store={store}>
      <UserProvider history={history}>
        <Router history={history}>
          <App />
        </Router>
      </UserProvider>
    </Provider>
  </ApolloProvider>
  </Suspense>
)

ReactDOM.render(app, document.getElementById('root'))
serviceWorker.unregister()
